import { BorderOuterOutlined } from "@ant-design/icons"
import { Button, Divider, Popconfirm, Space, Table, Typography } from "antd"
import React from "react"
import { useCollection } from "../../../hooks/useCollection"
import { Link } from "react-router-dom"
import { deleteDoc, doc } from "firebase/firestore"
import { db } from "../../../firebase/config"
import { Notification } from "../../../components/Notification"
import { useAuthContext } from "../../../hooks/useAuthContext"
import useFiltering from "../../../hooks/useFilters"

const { Title } = Typography

export default function Templates() {
  //user from auth context
  const { user } = useAuthContext()

  //gets data
  const { data, loading } = useCollection("priceTemplates", ["user", "==", user.uid])

  const { selectedFilters, handleTableFilterChange, filterOptions } = useFiltering(
    data,
    "Templates",
    ["templateName"]
  )

  //deleting the price
  const deleteData = async (e, docid) => {
    e.preventDefault()

    //price ref
    const ref = doc(db, "priceTemplates", docid)

    //deletes the price
    await deleteDoc(ref)
      .then(() => {
        Notification("warning", "Deleted!", "Template has been deleted!")
      })
      .catch((err) => {
        Notification("error", "Login Error", err.message)
      })
  }

  //default columns for table
  const defaultColumns = [
    {
      title: "Filter Group",
      dataIndex: "filterGroup",
      align: "center",
      width: "20%",
      filterSearch: true,
      filters: filterOptions.filterGroup,
      onFilter: (value, record) => record.filterGroup === value,
      filteredValue: selectedFilters.filterGroup || null,
      render: (value, record) => {
        if (record.hasFilterGroup) {
          return <>{record.filterGroup}</>
        } else {
          return "none"
        }
      },
    },
    {
      title: "Product",
      dataIndex: ["product", "productName"],
      align: "center",
      width: "20%",
      filters: filterOptions.product,
      filterSearch: true,
      onFilter: (value, record) => record.product.productName === value,
      filteredValue: selectedFilters.product || null, // Make sure this matches the filter key
    },
    {
      title: "Client",
      dataIndex: "client",
      align: "center",
      width: "20%",

      filters: filterOptions.client,
      onFilter: (value, record) => record.client === value,
      filteredValue: selectedFilters.client || null,
      filterSearch: true,
    },
    {
      title: "Width",
      dataIndex: "labelWidth",
      align: "center",
      sorter: (a, b) => a.labelWidth - b.labelWidth,
    },
    {
      title: "Height",
      dataIndex: "labelHeight",
      align: "center",
      sorter: (a, b) => a.labelHeight - b.labelHeight,
    },
    {
      title: "Template Name",
      dataIndex: "templateName",
      align: "center",
      width: "20%",
      filterSearch: true,
      filters: filterOptions.templateName,
      onFilter: (value, record) => record.templateName === value,
      filteredValue: selectedFilters.templateName || null,
    },
    {
      title: "Action",
      align: "center",
      width: "20%",
      render: (text, value) => {
        const templateState = { ...value, comingFromTemplate: true }

        return (
          <>
            <Space>
              <Link state={templateState} to="/calculations">
                <Button onClick={() => console.log(value)}>Use Template</Button>
              </Link>
              <Popconfirm
                onConfirm={(e) => deleteData(e, value.id)}
                title="Are you sure you want to delete?"
                okText="Yes"
                cancelText="No">
                <Button danger type="default">
                  Delete
                </Button>
              </Popconfirm>
            </Space>
          </>
        )
      },
    },
  ]

  return (
    <div style={{ padding: 15 }}>
      <Title level={3}>
        <BorderOuterOutlined />
        <Divider type="vertical" />
        Price Templates
      </Title>
      <Table
        key={JSON.stringify(selectedFilters)} // Forces re-render when filters change
        style={{ marginTop: "15px" }}
        size="small"
        loading={loading}
        columns={defaultColumns}
        bordered
        rowKey={(record) => record.id}
        dataSource={data && data}
        pagination={{ defaultPageSize: "12", showSizeChanger: true }}
        onChange={handleTableFilterChange}
      />
    </div>
  )
}
